/**
 * Mandatory: Make, Model
 * Optional: Category, RegMonth, RegDate, Variant (FaceLift), Body,
 *    Doors, Engine, EngineLiters, Fuel, Transmission, Wheeldrive, Seats
 * Commercial: BodyHeight, BodyLength, Weight
 */
export enum Relation {
  // Flow properties
  Sequence = 'sequence',
  Vin = 'vin',
  Reg = 'reg',
  Text = 'text',
  Valuation = 'valuation',
  Category = 'category',
  // Car properties
  Make = 'make',
  Model = 'model',
  RegMonth = 'regmonth',
  RegDate = 'regdate',
  Body = 'body',
  FaceLift = 'facelift',
  Seats = 'seats',
  Engine = 'engine',
  WheelDrive = 'wheeldrive',
  Transmission = 'transmission',
  Trim = 'trim',
  // Commercial car properties (i.e. VW Crafter)
  BodyHeight = 'bodyHeight',
  BodyLength = 'bodyLength',
  Weight = 'weight',
  Colors = 'colors',
}

export interface Image {
  key: string;
  links: Link[];
}

export interface NextStep {
  name: string;
  summary?: string;
  images: Image[];
  description: string[];
  href: string;
  type: string;
  rel: Relation;
  templated: boolean;
}

export interface Link {
  href: string;
  type: string;
  rel: Relation;
  templated: boolean;
}

export type TradeInDescriptionProp = {
  label: string;
  value: string;
};

export interface PrevStep {
  key: number[] | string;
  summary: string;
  name: string;
  assumed: boolean;
  description?: TradeInDescriptionProp[];
  link: Link;
}

export interface Valuation {
  variants: number[];
  seats: number;
  href: string;
  type: string;
  rel: 'valuation';
  templated: boolean;
}

export interface ProviderData {
  providerGroups: Entries[];
  providerName: string;
}

export interface Entry {
  key: string;
  value: string;
}

export interface Entries {
  type: string;
  entries: Entry[];
}

export interface IndicataResponse {
  nextStep: NextStep[];
  identifier?: string;
  valuation?: Valuation[];
  country: string;
  category?: PrevStep;
  make?: PrevStep;
  model?: PrevStep;
  regmonth?: PrevStep;
  regdate?: PrevStep;
  regDate?: PrevStep;
  body?: PrevStep;
  facelift?: PrevStep;
  seats?: PrevStep;
  engine?: PrevStep;
  wheeldrive?: PrevStep;
  transmission?: PrevStep;
  trim?: PrevStep;
  bodyHeight?: PrevStep;
  bodyLength?: PrevStep;
  weight?: PrevStep;
  providerData?: ProviderData;
  colors?: PrevStep;
}
